<template>
  <div class="swiper-main">
    <div class="title">chartered vehicle service</div>
    <div class="swiper-container1">
        <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="(item) in charterSwiperList" :key="item.id">
                <img loading="lazy"  :src="item.img" alt="">
                <div class="content">
                    <div class="lable" v-for="items in item.list" :key="items.id">
                        <span class="lable-num"></span><div class="lable-content">{{items.content}}</div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 导航按钮 -->
        <div class="next common"><img loading="lazy"  :src="next" alt=""></div>
        <div class="prev common"><img loading="lazy"  :src="prev" alt=""></div>
    </div>
  </div>
</template>

<script>
import 'swiper/dist/css/swiper.min.css'
import Swiper from 'swiper'
import next from '/static/img/newProductDetils/left1.png'
import prev from '/static/img/newProductDetils/right1.png'
import chartereSwiperInfo from '/js/experience/traffic/chartereSwiperInfo.js'
export default {
    data() {
        return {
            slides: [],
            swiper: null,
            next:next,
            prev:prev,
            charterSwiperList: chartereSwiperInfo.charterSwiperList
        }
    },
    mounted() {
        this.initSwiper()
        console.log(this.charterSwiperList)
    },
    watch:{
        swiperList:{
            handler(newVal){
                this.slides = newVal
            },
            deep:true,
            immediate:true
        },
    },
    methods: {
        slideClickEvent(id,slides){
            this.$emit('childSlideEvent',id,slides)
        },
        initSwiper() {
            this.swiper = new Swiper('.swiper-container1', {
                // 配置参数
                pagination: '.swiper-pagination',
                slidesPerView: 1,
                paginationClickable: true,
                spaceBetween: 30,
                keyboardControl: true,
                nextButton: '.next',
                prevButton: '.prev',
                // 其他Swiper3参数...
                loop: true, // 循环模式
                // autoplay: 3000, // 自动播放（ms）
            })
        },
    },
}
</script>

<style scoped lang="scss">
@import '/style/phone/experience/traffic/chartereSwiper.scss';
.swiper-main{
    width: 75rem;
    margin: 0 auto;
    overflow: hidden;
    .title{
        color: #09080D;
        text-align: center;
        font-feature-settings: 'liga' off, 'clig' off;
        font-size: 2.5rem;
        font-weight: 700;
        text-transform: capitalize;
        margin-bottom: 2.5rem;
        font-family: Butler;
    }
}
.swiper-container1 {
    width: 100%;
    height: 27rem; 
    position: relative;
}
.swiper-slide {
  display: flex;
  justify-content: center;
  align-items: center;
  img{
    width: 100%;
    height: 100%;
    border-radius: 0.5rem;
  }
}
.common{
    width: 2.5625rem;
    height: 2.5625rem;
    position: absolute;
    z-index: 99;
    bottom: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    background: #fff;
    img{
        width: 35%;
        height: 35%;
        display: block;
    }
}
.next{
    left: 1.25rem;
    cursor: pointer;
}
.prev{
    right: 1.25rem;
    cursor: pointer;
}
.content{
    position: absolute;
    bottom: 0;
    left: 0;
    width: calc(100% - 2.5rem);
    display: flex;
    padding: 1.25rem;
    justify-content: space-between;
    background: rgba(0, 0, 0, 0.44);
    .lable{
        width: 17.9375rem;
        color:  #FFF;
        font-family: Inter;
        font-size: 1.125rem;
        font-weight: 400;
        line-height: 1.6;
        display: flex;
        .lable-num{
            width: 0.625rem;
            height: 0.625rem;
            border-radius: 50%;
            background: #FFF;
            display: inline-block;
            margin-right: 0.625rem;
            margin-top: 0.625rem;
        }
        .lable-content{
            width: 17.3125rem;
            font-family: Inter;
        }
    }
    .lable:nth-child(1){
        width: 23.3125rem;
    }
}

</style>
